import React from 'react';
import PropTypes from 'prop-types';
import { Platform } from 'react-native';
export default function SvgRenderer(props) {
  const Svg = props.source;
  if (Platform.OS !== 'web') return /*#__PURE__*/React.createElement(Svg, props);
  const style = {};
  if (props.height) style.height = props.height;
  if (props.width) style.width = props.width;
  return /*#__PURE__*/React.createElement("img", {
    src: Svg,
    alt: Svg,
    style: style
  });
}
SvgRenderer.propTypes = {
  source: PropTypes.elementType.isRequired,
  // eslint-disable-next-line react/require-default-props
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  // eslint-disable-next-line react/require-default-props
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
//# sourceMappingURL=index.js.map